export default "__VITE_ASSET__ks6VinNb__"